import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from 'seagull';
import { Typography } from 'seagull/components/Typography';
import ExpirationDate from '~/components/AgreementStudioPage/AgreementStudioModal/ExpirationDate/ExpirationDate';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { useStore } from '~/store/store-context';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
export default function ExpirationDateCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const worksAt = useStore(selectors.user.business);
    const expirationDaysAfterSending = draft.expirationDaysAfterSending();
    const defaultExpirationDays = draft.defaultExpirationDays(worksAt);
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: draftCellsTexts.expirationDate(),
                    testId: 'edit-expiration-date-modal',
                    content: /*#__PURE__*/ _jsx(Grid, {
                        rowGap: "small",
                        children: /*#__PURE__*/ _jsx(ExpirationDate, {
                            daysToExpiration: draft.expirationDaysAfterSending() || 0,
                            hasExpirationDate: draft.expirationDaysAfterSending() !== null,
                            setDaysToExpiration: (days)=>setDraft(draft.setExpirationDate({
                                    type: 'days',
                                    days
                                })),
                            setHasExpirationDate: (hasExpirationDate)=>setDraft(draft.setExpirationDate(hasExpirationDate ? {
                                    type: 'days',
                                    days: defaultExpirationDays || draft.expirationDaysAfterSending() || 30
                                } : null))
                        })
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-expiration-date-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "expiration-date-".concat(index),
            children: expirationDaysAfterSending != null ? editTableTexts.daysAfterSending({
                count: expirationDaysAfterSending
            }) : editTableTexts.notSet()
        })
    });
}
